

import {
  AUTHENTICATE_IMPORTANT_MOMENT_STREAM_REQUEST,
  AUTHENTICATE_IMPORTANT_MOMENT_STREAM_SUCCESS,
  AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE,
} from 'Store/constants';
  
const initialState = {

  activeStreamInfo: {
    url: null,
    streamId: null,
    provider: null,
    isPlaying: false,
    error: null
  },
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case AUTHENTICATE_IMPORTANT_MOMENT_STREAM_REQUEST:
      return {
        ...state,
        activeStreamInfo: {
          url: null,
          provider: null,
          isLoading: true,
          error: null
        }
      };
  
    case AUTHENTICATE_IMPORTANT_MOMENT_STREAM_SUCCESS:
      return {
        ...state,
        activeStreamInfo: {
          url: action.payload.url,
          provider: action.payload.provider,
          statusCode: action.payload.code,
          description: action.payload.description,
          streamId: action.payload?.streamId,
          isLoading: false,
          error: null
        }
      };
       
    case AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE:
      return {
        ...state,
        activeStreamInfo: {
          provider: null,
          url: null,
          isLoading: false,
          error: action.payload
        }
      };
  
  
    default:
      return state;
  }
};
  